import React from 'react';
import { Card } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { cohortUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import { showDatasetConditions } from '@/datasets/conditions/actions';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import CohortTools from './CohortTools';
import cohortStatus from '../status/helper';
import CohortStatusButtons from '../status/components/CohortStatusButtons';

const CohortCardItem = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  category,
  cohort,
  hasConditions,
  onCheckBoxClick,
  newRequestCode,
  showConditions,
  showStatus,
  showTools,
  single,
  upward,
}) => (
  <CardItem className="aridhia-cohort-list-item">
    <NameDescriptionCard
      description={cohort.description}
      entity="cohort"
      link={cohortUrl(cohort)}
      markdown
      name={cohort.name}
      onSelect={onCheckBoxClick ? () => onCheckBoxClick(cohort.code) : undefined}
      selected={cohort.selected}
      single={single}
      visibility={cohort.visibility}
    >
      {showTools && (
      <CohortTools
        category={category}
        cohort={cohort}
        iconSize="large"
        listItem
        upward={upward}
        url={cohortUrl(cohort, '#')}
      />
      )}
    </NameDescriptionCard>
    <Card.Content extra>
      <span>{cohort.createdOn}</span>
      {showStatus && accessRequestAllowed && (
      <CohortStatusButtons
        accessRequestAllowed={accessRequestAllowed}
        accessRequestSupported={accessRequestSupported}
        accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
        code={cohort.code}
        className="float-r"
        hasConditions={hasConditions}
        icon
        name={cohort.name}
        newRequestCode={newRequestCode}
        showConditions={showConditions}
        workflowKey={cohort.settings.workflow_key}
      />
      )}
    </Card.Content>
  </CardItem>
);

const mapStateToProps = ({
  auth: { role },
  requests: { newRequestCode },
}, { cohort }) => ({
  newRequestCode,
  ...cohortStatus(role, cohort),
});

const mapDispatchToProps = {
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortCardItem);
